import React, {useEffect, useState} from 'react';
import Api from '../../../../interface/api/host';
export default function MyInfo() {

    const hostInfo = JSON.parse(localStorage.getItem('hostInfo'));

    const [ password, setPassword ] = useState({
        prevPassword : '',
        nextPassword : '',
    })

    function passwordChangeSubmitHandler() {
        Api.changePassword(hostInfo.number, password.prevPassword, password.nextPassword).then(res => alert('정상적으로 변경되었습니다.'));
    }

    return (
        <>
            <div className="nv_contents">
                <div className="nv_table_tit regist_tit">
                    <h4>내 계정 정보</h4>
                </div>
                <div className="nv_table_box">
                    <dl className="nv_dl_table">
                        <dt>소속</dt>
                        <dd className="nv_dd_full">
                            <input type="text"
                                   className="nv_input max_200"
                                   id="host_site_info"
                                   name="host_site_info"
                                   value={`${hostInfo.siteInfo.parentSiteInfo.name}, ${hostInfo.siteInfo.name}`}
                                   readOnly/>
                        </dd>
                        <dt>팀</dt>
                        <dd className="nv_dd_full">
                            <input type="text"
                                   className="nv_input max_200"
                                   id="host_team"
                                   name="host_team"
                                   value={hostInfo.team}
                                   readOnly/>
                        </dd>
                        <dt>사번</dt>
                        <dd className="nv_dd_full">
                            <input type="text"
                                   className="nv_input max_200"
                                   id="host_number"
                                   name="host_number"
                                   value={hostInfo.number}
                                   readOnly/>
                        </dd>
                        <dt>이름</dt>
                        <dd className="nv_dd_full">
                            <input type="text"
                                   className="nv_input max_200"
                                   id="host_name"
                                   name="host_name"
                                   value={hostInfo.name}
                                   readOnly/>
                        </dd>
                        <dt>연락처</dt>
                        <dd className="nv_dd_full">
                            <input type="text"
                                   className="nv_input max_200"
                                   id="host_phone"
                                   name="host_phone"
                                   value={hostInfo.phone}
                                   readOnly/>
                        </dd>
                        <dt>이메일</dt>
                        <dd className="nv_dd_full">
                            <input type="text"
                                   className="nv_input max_200"
                                   id="host_email"
                                   name="host_email"
                                   value={hostInfo.email}
                                   readOnly/>
                        </dd>
                    </dl>
                </div>
                <div className="nv_table_tit regist_tit">
                    <h4>비밀번호 변경</h4>
                </div>
                <div className="nv_table_box">
                    <dl className="nv_dl_table">
                        <dt>현재 비밀번호</dt>
                        <dd className="nv_dd_full">
                            <input type="password" className="nv_input max_200" onChange={(e) => setPassword({...password, prevPassword:e.target.value})}/>
                        </dd>
                        <dt>변경할 비밀번호</dt>
                        <dd className="nv_dd_full">
                            <input type="password" className="nv_input max_200" onChange={(e) => setPassword({...password, nextPassword:e.target.value})}/>
                        </dd>
                        <dt></dt>
                        <dd className="nv_dd_full">
                            <button type="button" className="nv_blue_button m_w_100" onClick={passwordChangeSubmitHandler} >변경</button>
                        </dd>
                    </dl>
                </div>

            </div>
        </>
    )
}